import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { IEventHandler, EventHandlerListener } from '@lmnop/web-core';
import { NgxSpinnerService } from 'ngx-spinner';

export class OnToggleButtonChangeEventArgs {
    constructor(value: boolean, id?: string | number) {
        this.value = value;
        this.id = id;
    }

    public value: boolean;
    public id: string | number;
}

// TODO: tudnia kell a komponensnek embedded szöveget és embedded ikont
@Component({
    selector: 'toggle-button',
    templateUrl: 'toggle-button.control.html',
    styleUrl: './toggle-button.control.scss',
    standalone: false,
})
export class ToggleButtonControl extends ControlBase {
    constructor(
        private cdr: ChangeDetectorRef,
        protected override spinnerService: NgxSpinnerService
    ) {
        super(spinnerService);
    }

    @Input()
    public isChecked: boolean;
    @Input()
    public toggleText: string;
    @Input()
    public idText: string;

    // Assign a toggle button to each list item and use the itemId to identify the correct toggle event for each item.
    @Input()
    public itemId: string | number = 0;

    private eventNameAndTranslatePrefix: string;

    public onToggleClick(): void {
        this.toggleText = this.getToggleTranslatedText(this.isChecked);
        this.ioc.core.eventHandler.emit(this.eventNameAndTranslatePrefix, new OnToggleButtonChangeEventArgs(this.isChecked, this.itemId));
    }

    private getToggleTranslatedText(value: boolean): string {
        let onOffTexts: string[] = [this.eventNameAndTranslatePrefix + '.on', this.eventNameAndTranslatePrefix + '.off'];
        let toTranslate: string = value ? onOffTexts[0] : onOffTexts[1];
        return this.ioc.core.translation.getMessage(toTranslate);
    }

    public initToggleButton<T>(value: boolean, eventNameAndTranslatePrefix: string, onChangeFunction: EventHandlerListener<T>) {
        if (!eventNameAndTranslatePrefix.endsWith('_on_off')) {
            throw new Error('eventNameAndTranslatePrefix must ends with `_on_off` postfix');
        }
        this.isChecked = value;
        this.eventNameAndTranslatePrefix = eventNameAndTranslatePrefix;
        this.toggleText = this.getToggleTranslatedText(value);
        this.ioc.core.eventHandler.on(this.eventNameAndTranslatePrefix, onChangeFunction);
        //needed if the buttons are initialized in a ngAfterViewInit function
        this.cdr.detectChanges();
    }
}
